import { useRouter } from 'next/router';
import useClientAccountProfileQuery from '../../queries/useClientAccountProfileQuery';

export const USERID_QUERY_KEY = 'userId';
export const OLD_USERID_QUERY_KEY = 'user_id';

export default function useUserId() {
  const { data } = useClientAccountProfileQuery();
  const router = useRouter();

  const isAdmin = !!data?.isAdmin;
  const sessionUserId = data?.id || null;
  const newQueryUserId = router.query[USERID_QUERY_KEY]
    ? Number(router.query[USERID_QUERY_KEY])
    : null;
  const oldQueryUserId = router.query[OLD_USERID_QUERY_KEY]
    ? Number(router.query[OLD_USERID_QUERY_KEY])
    : null;

  const queryUserId = newQueryUserId || oldQueryUserId;

  return {
    queryUserId,
    sessionUserId,
    targetUserId: isAdmin && queryUserId ? queryUserId : sessionUserId,
  };
}
